import { QueryConfig, QueryResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export type Configuration = {
    //Venta
    paySeparately: boolean,
    requireVentaAuthorization: boolean,
    ventaAuthorizationPassword: string,
    defaultPrecioIndex: number,
    articuloNombreMaxLength: number,

    //Factura
    marginTopPx: number,
    itemsPerPage: number,
    horizontal: boolean,
    genericClientId: string,
    showMonedaId: string,
    modeTicket: boolean,
    printFont: string,
    printFontSize: number,
    printPaddingRight: number,
    printPaperWidth: string,
    ticketHeader: string,
    ticketItemIdentifier: string,
    nuevaVentaItemIdentifier: string,
    ticketFooter: string,
    kudeItemsPerPage: number,
}

export async function getConfiguration(): Promise<Configuration> {
    await sleep(1000);
    const response = await api.get("configuration");
    return response.data;
}

export function useGetConfigurationQuery(queryConfig: QueryConfig<Configuration> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: getConfiguration,
        queryKey: ["configuration"],
    })
}

export interface GetConfigurationQueryProps {
    queryConfig?: QueryConfig<Configuration>,
    children?: (queryResult: QueryResult<Configuration>) => ReactNode
}

export function GetConfigurationQuery({
    children,
    queryConfig
}: GetConfigurationQueryProps) {
    const queryResult = useGetConfigurationQuery(queryConfig);
    return children && children(queryResult);
}